// ProjectContext.tsx
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface ProjectContextProps {
  selectedProject: string;
  setSelectedProject: (project: string) => void;
}

export const ProjectContext = createContext<ProjectContextProps | undefined>(undefined);

type ProjectProviderProps = { children: React.ReactNode };

export const ProjectProvider: React.FC<ProjectProviderProps> = ({ children }) => {
  // Initialize state from localStorage
  const [selectedProject, setSelectedProjectState] = useState<string>(
    localStorage.getItem('selectedProject') || ''
  );

  const setSelectedProject = useCallback((project: string) => {
    setSelectedProjectState(project);
    if (project) {
      localStorage.setItem('selectedProject', project);
    } else {
      localStorage.removeItem('selectedProject');
    }
  }, []);

  const contextValue = useMemo(
    () => ({ selectedProject, setSelectedProject }),
    [selectedProject, setSelectedProject]
  );

  return (
    <ProjectContext.Provider value={contextValue}>
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjectContext must be used within a ProjectProvider');
  }
  return context;
};